import React from 'react';
import App from './components/App';
// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker
//   `messaging.onBackgroundMessage` handler.

import { getMessaging, onMessage } from "firebase/messaging";
import { createRoot } from 'react-dom/client';
import ReactGA from "react-ga4"


ReactGA.initialize("G-QWFLGGRNS6")
const messaging = getMessaging();

onMessage(messaging, (payload) => {
Notification.requestPermission().then((permission) => {
    if(permission ==="granted"){
        if(payload.notification){
            new Notification(payload.notification.title, {body:payload.notification.body})
        }

    } else{
        console.error("Message received but not displayed because of permissions")
    }
})
});

const domNode = document.getElementById('root');

const root = createRoot(domNode);

root.render(<App />);